/* create Select with overlay videos */
function createOverlayVideoSelect() {
    const namesArray = overlayVideoData.map(function (item) {
        let result = item.tod;

        item.name != '' && (result += ` ${item.name}`);
        item.bib != '' && (result += ` ${item.bib}`);

        return { option: result, checked: item.checked };
    });

    const urlArray = overlayVideoData.map((item) => item.video);

    createSelect2Single(
        '.js-video-overlay-select-athlete-wrapper',
        namesArray,
        'Athlete name',
        urlArray,
        true
    );
}

runIfElementExist(
    createOverlayVideoSelect,
    '.js-video-overlay-select-athlete-wrapper'
);

/* CANCEL button clicked */
$('.mdl-wrap').on('click', '.js-cancel-video-overlay-select-btn', function () {
    $('.js-video-overlay-select-athlete-wrapper .js-select2')
        .val(null)
        .trigger('change');

    $('.js-apply-video-overlay-select-btn').prop('disabled', true);
});

let videoOverlayUrl;
let videoOverlayIndex;

/* APPLY button clicked */
$('.mdl-wrap').on('click', '.js-apply-video-overlay-select-btn', function () {
    isOverlayed = true;
    /* get url of the selected video from data-additional */
    videoOverlayUrl = $('.js-video-overlay-select-athlete-wrapper .js-select2')
        .find(':selected')
        .data('additional');
    videoOverlayIndex = $(
        '.js-video-overlay-select-athlete-wrapper .js-select2'
    )
        .find(':selected')
        .data('index');

    // initialize overlay video player
    adjustPlayerWithOverlay(videoOverlayUrl, videoOverlayIndex);

    $('.js-video-player .vjs-tech').addClass('opacity-05');
    $('.js-btn-video-overlay').addClass('active');
    $('.js-btn-video-zoom').prop('disabled', true);
    $('.js-btn-video-frostlines').prop('disabled', true);
});

/* APPLY button is active */
$(document).on(
    'change',
    '.js-video-overlay-select-athlete-wrapper .js-select2',
    function () {
        $('.js-apply-video-overlay-select-btn').prop('disabled', false);
    }
);
